module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy.bd5876de.pdf";